<template>
  <document-container
      v-if="template"
      :body="template.body()"
      :footer="template.footer()"
      :header="template.header()"
      :logo="logo"
      :tables="flatTableGroups"
      documentType="shortlist"
      orientation="landscape"
  >
    <div
        v-if="environment === 'blsk'"
        slot="raw-body"
        class="page-block "
    >
      <div class="textblock disclaimer-emphasis">
        Nur zum internen Gebrauch | {{ time }}
      </div>
    </div>


    <div
        v-if="mode === 'SCHREIBTISCH'"
        slot="raw-body"
        class="page-block"
    >
      <div class="textblock disclaimer-emphasis" style="color: red; font-style: italic">

        Bitte beachten: Individualkundenberatende II alle Produkte freigegeben, deren ein Index als Basiswert zugrundeliegt (außer Nachkaufzertifikate)”
      </div>
    </div>

    <div
        v-if="mode === 'SCHREIBTISCH'"
        slot="raw-footer"
        class="page-block"
    >
      <span style="color: red">Stadtsparkasse Düsseldorf - {{ time }} </span></div>


    <div
        v-for="block in template.body().filter(block => block.sort === undefined || (block.sort < 100))"
        slot="raw-body" class="page-block">

      <component
          :is="block.type"
          :data="block"
      ></component>
    </div>

    <template v-for="(tableGroup, groupKey) in tableGroups">
      <div
          v-for="(table, tableKey) in tableGroup.tables"
          slot="raw-body"
          class="page-block"
      >
        <TableShortlistProducts
            :id="groupKey + ':' + table.title"
            :group-title="tableKey === 0 ? labels[groupKey] : null"
            :show-time="false"
            :table="table"
        ></TableShortlistProducts>

      </div>
    </template>


    <div
        v-for="block in template.body().filter(block => block.sort >= 100)"
        slot="raw-body" class="page-block">

      <component
          :is="block.type"
          :data="block"
      ></component>
    </div>
  </document-container>
</template>

<script>
import DocumentContainer
  from '../document/DocumentContainer'
import BlockMixin
  from '../block/BlockMixin'
import {
  TableCollection,
} from '../../model/table/TableCollection'
import ProductService
  from "../../service/ProductService"
import {
  Table,
} from "../../model/table/Table"
import * as ConfigService
  from "../../service/ConfigService"
import TemplateManager
  from "../../service/TemplateManager"
import TableShortlistProducts
  from "../table/TableShortlistProducts"
import TokenService
  from "../../service/TokenService"

export default {
  name: 'shortlist',
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/shortlist.css',
        },
      ]
    },
  },
  data() {
    return {
      token: null,
      template: null,
      tableGroups: [],
      instrumentTypes: [
        {
          label: 'Derivate',
          id: 'derivate',
        },
        {
          label: 'Bonds',
          id: 'bonds',
        },
        {
          label: 'Fonds',
          id: 'funds',
        },
        {
          label: 'Aktien',
          id: 'stocks',
        },
        {
          label: 'Trades',
          id: 'trades',
        },
        {
          label: 'Assets',
          id: 'assets',
        },
      ],
      labels: [],
      mode: null
    }
  },

  mixins: [BlockMixin],

  props: {
    environment: {
      type: String,
      required: true,
    },
    shortlistId: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  computed: {
    logo() {
      return ['config', this.environment, 'images', 'logo.png'].join('/')
    },
    flatTableGroups() {
      let tables = []
      for (let tableGroup of this.tableGroups) {
        tables = [...tables, ...tableGroup.tables]
      }
      return new TableCollection(...tables)
//       }
    },
    time() {
      return this.moment().format('[Stand:] DD.MM.YYYY')
    },
  },

  methods: {
    getTemplateManager(template) {
      return new TemplateManager(template)
    },
  },

  async created() {
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }

    this.mode = this.$route.query.context


    const response = await ProductService.getShortlist(this.environment, this.appInstance, this.shortlistId, this.token, this._.get(this.$route, 'query.dqs', null))

    ConfigService.getDocumentConfig(
        this.environment,
        'shortlist',
        'default',
        'default',
    ).then(documentConfig => {
      documentConfig.data.title.title = response.data.data.shortlistName

      // overrides for document title
      if(this.mode === 'SCHREIBTISCH') {
        documentConfig.data.title.title = 'Schreibtischunterlage Zertifikate'
      }
      if (this.shortlistId === '6576dd366def0a3c5f8493e8') {
        documentConfig.data.title.title = "Fonds Exklusiv"
      }

      this.template = this.getTemplateManager(documentConfig.data)
      console.log(this.template)
    })

    response.data.data.groups.map((el, key) => {
      this.labels.push(el.label)
      this.tableGroups.push(
          new TableCollection(
              ...el.tables.map(table => {
                    return new Table(
                        key + ':' + table.heading,
                        table.columns,
                        table.products,
                        TableShortlistProducts,
                        table.heading,
                    )
                  },
              ),
          ),
      )
    })
  },

  components: {
    DocumentContainer,
    TableShortlistProducts,
  },
}
</script>



// WEBPACK FOOTER //
// Shortlist.vue?10cda628